import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { logger } from '@/utils/logger';

let app: FirebaseApp | null = null;
let auth: Auth | null = null;
let db: Firestore | null = null;

/**
 * Firebaseを初期化
 */
export function initializeFirebase(): { app: FirebaseApp; auth: Auth; db: Firestore } | null {
  // 環境変数が設定されていない場合はnullを返す
  if (!import.meta.env.VITE_FIREBASE_API_KEY) {
    logger.warn('Firebase環境変数が設定されていません。Firebase機能は無効です。');
    return null;
  }

  try {
    const firebaseConfig = {
      apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
      authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
      projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
      storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
      appId: import.meta.env.VITE_FIREBASE_APP_ID,
    };

    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    db = getFirestore(app);

    logger.log('Firebase initialized successfully');
    return { app, auth, db };
  } catch (error) {
    logger.error('Firebase initialization error:', error);
    return null;
  }
}

/**
 * Firebaseインスタンスを取得
 */
export function getFirebaseInstances() {
  if (!app || !auth || !db) {
    return initializeFirebase();
  }
  return { app, auth, db };
}
